module.exports = __webpack_public_path__ + "static/interview01-cb2db15419bf0cd64680659d3da117f7.jpg";